import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialLinkedin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M6.984 9.197H3.295V21h3.689zm.332-4.058A2.124 2.124 0 0 0 5.206 3h-.067a2.14 2.14 0 1 0 0 4.279 2.125 2.125 0 0 0 2.177-2.073zM21 13.83c0-3.548-2.257-4.927-4.5-4.927a4.2 4.2 0 0 0-3.733 1.903h-.103V9.197H9.197V21h3.688v-6.278a2.45 2.45 0 0 1 2.213-2.64h.14c1.174 0 2.044.737 2.044 2.596V21h3.689z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialLinkedin) as SvgIcon;
export { ForwardRef as ReactComponent };
